import { FC, useEffect, useMemo, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import {CircularProgress} from '@mui/material';
import { useWallet } from '@solana/wallet-adapter-react';

import RaffleCard from '../../components/RaffleCard';
import { useStyles } from './styles';
import { useRafflesStore } from '../../hooks/useRafflesStore';
import Screen from '../../components/layout/Screen';
import { Raffle } from '../../lib/types';
import { useViewport } from '../../hooks/useViewport';
import FilterBar from './components/FilterBar';
//tokens
import { tokenInfoMap } from '../../config/tokenRegistry';
//input
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Footer from "../../components/layout/Footer"
const ExploreRafflesScreen: FC = () => {
  const { device } = useViewport();
  const classes = useStyles({ device });
  const { publicKey } = useWallet();
  const { homeRaffles, fetchHomeRaffles, homeFetching } = useRafflesStore();
  const [showOwnRafflesOnly, setShowOwnRafflesOnly] = useState(false);
  const [hideEndedRaffles, setHideEndedRaffles] = useState(false);
  const [featuredRaffles, setFeaturedRaffles] = useState<Raffle[]>([]);
  const [tokenFilter, setTokenFilter] = useState<string>('All Tokens');

  useEffect(fetchHomeRaffles, [fetchHomeRaffles]);

  const handleChange = (event: any) => {
    setTokenFilter(event.target.value as string);
  };
  const filterMap = useMemo(
    () => ({
      own: (raffle: Raffle) => raffle.entrants.has(publicKey?.toString() || ''),
      ongoing: (raffle: Raffle) => new Date() < raffle.endTimestamp,
      featured: (raffle: Raffle) => raffle.featured === true,
      tokenFilter: (raffle: Raffle) =>
        raffle.proceeds.mint.symbol === tokenFilter,
    }),
    [publicKey]
  );

  const rafflesToShow = useMemo(() => {
    let toShow = [...homeRaffles.values()].sort(
      (raffle1, raffle2) =>
        raffle1.endTimestamp.getTime() - raffle2.endTimestamp.getTime()
    );
    if (showOwnRafflesOnly) toShow = toShow.filter(filterMap.own);
    if (hideEndedRaffles) toShow = toShow.filter(filterMap.ongoing);
    if (tokenFilter !== 'All Tokens') {
      toShow = toShow.filter(
        (raffle: Raffle) => raffle.proceeds.mint.symbol === tokenFilter
      );
      // console.log('filtering based on token ', tokenFilter);
      // console.log('result', toShow.filter((raffle:Raffle)=>raffle.proceeds.mint.symbol === tokenFilter));
    }
    return toShow;
  }, [
    homeRaffles,
    filterMap,
    showOwnRafflesOnly,
    hideEndedRaffles,
    tokenFilter,
  ]);

  useEffect(() => {
    if (homeRaffles) {
      let toShow = [...homeRaffles.values()].sort(
        (raffle1, raffle2) =>
          raffle1.endTimestamp.getTime() - raffle2.endTimestamp.getTime()
      );
      setFeaturedRaffles(toShow.filter(filterMap.featured));

      // console.log(typeof toShow, toShow)
    }
  }, [homeRaffles]);

  if (homeRaffles.size === 0 && homeFetching)
    return (
      <div className="h-50vh">
        {/* <h1 className="text-brand_secondary text-center w-full">
          EXPLORE RAFFLES
        </h1> */}
        <div className={classes.mainContent}>
          <CircularProgress sx={{ color: 'white' }} />
        </div>
      </div>
    );

  if (homeRaffles.size === 0)
    return (
      <div className="h-50vh">
        {/* <h1 className="text-brand_secondary bg-green-200 text-center w-full">
          EXPLORE RAFFLES
        </h1> */}
        <div className="MBJChunky bg-green-00 flex justify-center text-3xl md:text-6xl pt-24 text-white">
          {' '}
          HELLO ...
          {publicKey?.toBase58().charAt(publicKey?.toBase58().length - 4)}
          {publicKey?.toBase58().charAt(publicKey?.toBase58().length - 3)}
          {publicKey?.toBase58().charAt(publicKey?.toBase58().length - 2)}
          {publicKey?.toBase58().charAt(publicKey?.toBase58().length - 1)}{' '}
        </div>
        <div className="GTWalsheimProBold text-white text- md:text-2xl bg-green-00 flex justify-center">
          {' '}
          Welcome to the Miners of Mars $OSM raffles.{' '}
        </div>
        <h4 className={classes.mainContent}>Raffles will be coming soon!</h4>
      </div>
    );

  return (
    <div className="w-full">
      <div className="w-full">
      </div>
      <div className="w-full flex  mb-3 flex-wrap md:justify-between md:p-4">
        <FilterBar
          hideEndedRaffles={hideEndedRaffles}
          setHideEndedRaffles={setHideEndedRaffles}
          setShowOwnRafflesOnly={setShowOwnRafflesOnly}
          showOwnRafflesOnly={showOwnRafflesOnly}
        />
        <div className="w-full bg-yellow-00 md:w-2/12">
          <FormControl className="w-full">
            <label
              id="demo-simple-select-label"
              className="GTWalsheimProBold tracking-wider text-white text-center lg:text-left"
            >
              Choose Token
            </label>
            <Select
            style={{color:"white"}}
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={tokenFilter}
              onChange={handleChange}
            >
              <MenuItem value="All Tokens" >All Tokens</MenuItem>
              {Array.from(tokenInfoMap.values())
                .filter((t) => t.symbol)
                .map((item: any) => (
                  <MenuItem
                    value={item.symbol}
                    key={item.symbol + Math.random()}
                  >
                    {item.symbol}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      </div>
      {rafflesToShow.length > 0 ? (
        <div
          className={`flex flex-wrap justify-center md:justify-between`}
        >
          {rafflesToShow
            .filter((r) => r.prizes.length > 0)
            .map((raffle) => {
              // console.log(raffle.proceeds.mint.symbol === tokenFilter, 'i')
              return (
                <RaffleCard
                  key={raffle.publicKey.toString()}
                  className={classes.raffleCardContainer}
                  raffle={raffle}
                />
              );
            })}
        </div>
      ) : (
        <h4 className={classes.mainContent}>No Raffles to display.</h4>
      )}
      <div className="p-4"><Footer/></div>
      
    </div>
  );
};

const ExploreRafflesScreenWithLayout = () => (
  <Screen>
    <ExploreRafflesScreen />
  </Screen>
);
const FeaturedRaffles = (props: any) => {
  const classes = props.classes;
  const homeRaffles = props.homeRaffles;
  // console.log(homeRaffles, 'featured homeRaffles');
  return (
    <div className="w-full">
      <Typography variant="h1" className={classes.titleBar}>
        FEATURED
      </Typography>
      <div className="flex w-full flex-wrap justify-center items-center">
        {homeRaffles.map((item: Raffle) => {
          return (
            <RaffleCard
              key={item.publicKey.toString()}
              className={classes.raffleCardContainer}
              raffle={item}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExploreRafflesScreenWithLayout;
